import AccessibilityUtilities from "./utilities/accessibility.js";
import cardsInit from "./components/card";
import newsFeedInit from "./components/news-feed";
import newsFeatureListInit from "./components/news-feature-list";
import accordionInit from "./components/accordion";
import carouselInit from "./components/carousel";
import siteHeaderInit from "./components/site-header";
import videoEmbedInit from "./components/video-embed";
import modalInit from "./components/modal";
import subnavInit from "./components/subnav";
import landingPageSubnavInit from "./components/landing-page-subnav";
import cookieBarInit from "./components/cookies";
import tabsInit from "./components/tabs";
import homeHeroInit from "./components/home-hero";
import newsFeatureGridInit from "./components/news-feature-grid";

document.addEventListener("DOMContentLoaded", () => {
  AccessibilityUtilities.init();
  cardsInit();
  newsFeedInit();
  accordionInit();
  carouselInit();
  modalInit();
  subnavInit();
  landingPageSubnavInit();
  videoEmbedInit();
  siteHeaderInit();
  cookieBarInit();
  tabsInit();
  homeHeroInit();
  newsFeatureListInit();
  newsFeatureGridInit();
});
